<!--

	Was macht diese Componente?
	Wofür ist die Compoente da?

	Welche $props gibt es?

	Beispiel Code:
		<AppSidebar></AppSidebar>

	2021-07-05	init

-->

<template>
	<div class="AppSidebar" name="AppSidebar" :class="elmClasses">
		<div class="AppSidebar__inner">
			<!-- logo -->
			<div class="AppSidebar__logo AppSidebar__box">
				<router-link :to="'/'"></router-link>
			</div>

			<!-- widgets -->
			<template v-if="$route.name === 'HomeView'">
				<div class="AppSidebar__box">
					<!--
					<BaseButton>
						<template slot="before"></template>
						<template slot="default">Eins</template>
						<template slot="after">
							<BaseIcon type="arrow-right"></BaseIcon>
						</template>
					</BaseButton> •
					<BaseButton :isOutlined="true">
						<template slot="before"></template>
						<template slot="default">Zwei</template>
						<template slot="after">
							<BaseIcon type="arrow-right"></BaseIcon>
						</template>
					</BaseButton>
					<hr>
					<BaseButton :isDisabled="true">
						<template slot="before"></template>
						<template slot="default">Heiko</template>
						<template slot="after">
							<BaseIcon type="arrow-right"></BaseIcon>
						</template>
					</BaseButton> •
					<BaseButton :isOutlined="true" :isDisabled="true">
						<template slot="before"></template>
						<template slot="default">Heiko</template>
						<template slot="after">
							<BaseIcon type="arrow-right"></BaseIcon>
						</template>
					</BaseButton>
					<hr>
					<BaseFileInput
						:accept="''"
						:multiple="true"
						@input="(e)=>{}"
						@change="(e)=>{}">
						<template slot="before"></template>
						<template slot="default">Choose ...</template>
						<template slot="after">
							<BaseIcon type="upload"></BaseIcon>
						</template>
					</BaseFileInput> •
					<BaseFileInput
						:isDisabled="true"
						:accept="''"
						:multiple="false"
						@input="(e)=>{}"
						@change="(e)=>{}">
						<template slot="before">
							<BaseIcon type="upload"></BaseIcon>
						</template>
						<template slot="default">Choose ...</template>
						<template slot="after"></template>
					</BaseFileInput>
					<hr>
					<BaseFileInput
						:isOutlined="true"
						:accept="''"
						:multiple="true"
						@input="(e)=>{}"
						@change="(e)=>{}">
						<template slot="before">
							<BaseIcon type="upload"></BaseIcon>
						</template>
						<template slot="default">Choose ...</template>
						<template slot="after"></template>
					</BaseFileInput> •
					<BaseFileInput
						:isOutlined="true"
						:isDisabled="true"
						:accept="''"
						:multiple="true"
						@input="(e)=>{}"
						@change="(e)=>{}">
						<template slot="before"></template>
						<template slot="default">Choose ...</template>
						<template slot="after">
							<BaseIcon type="upload"></BaseIcon>
						</template>
					</BaseFileInput>
					-->
				</div>
			</template>

			<!-- widgets -->
			<template v-if="$route.name === 'EditView'">
				<div class="AppSidebar__box AppSidebar__box--progress">
					<strong>Fortschritt</strong><br/>
					<br/>
					<BaseProgressBar :value="doc.validPercentage"></BaseProgressBar>

					<div class="flex flex--spaceBetween">
						<span class="">Datensätze insgesamt</span><strong>{{doc.countDataRows}}</strong>
					</div>
					<div class="flex flex--spaceBetween">
						<span>Invalide Datensätze</span>
						<strong :class="{
							'color color--red' : doc.countInvalidDataRows,
							'color color--green' : !doc.countInvalidDataRows,
						}">{{doc.countInvalidDataRows}}</strong>
					</div>
					<div class="flex flex--spaceBetween">
						<span class="">Invalide Felder</span>
						<strong :class="{
							'color color--red' : doc.countInvalidDataRows,
							'color color--green' : !doc.countInvalidDataRows,
						}">{{doc.countInvalidValues}}</strong>
					</div>
				</div>
				<div class="AppSidebar__box AppSidebar__box--download hyphenate">
					<strong>Download</strong><br/>
					<br/>
					<p>
						Zu jedem Zeitpunkt kann eine CSV-Datei mit den Datensätzen heruntergeladen werden.
						Wenn die Datensätze invalide Felder enthalten, wird dem CSV-Dateinamen “--invalid” angehängt.
					</p>
					<BaseButton @click.native="doDownloadCsv">
						<template slot="before"></template>
						<template slot="default">Download CSV-Datei</template>
						<template slot="after">
							<BaseIcon type="download"></BaseIcon>
						</template>
					</BaseButton>

				</div>
			</template>

			<!-- footer -->
			<div class="AppSidebar__expander"></div>
			<div class="AppSidebar__footer AppSidebar__box AppSidebar__box--footer">
				<a class="link" @click="app.showImprintModal = true">Impressum</a>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import DevInfos from '@/components/DevInfos.vue'
	import { EventBus } from './../../event-bus.js'
	import BaseProgressBar from './BaseProgressBar.vue'
	import BaseIcon from './BaseIcon.vue'
	import BaseButton from '/Users/Mario/Dropbox/htdocs/2020-09-17__MhForm/vue-cli-dev/src/components/MhForm/v3/BaseButton.vue'
	import BaseFileInput from '/Users/Mario/Dropbox/htdocs/2020-09-17__MhForm/vue-cli-dev/src/components/MhForm/v3/BaseFileInput.vue'

	export default {
		name: 'AppSidebar',
		components: {
			BaseProgressBar,
			BaseButton,
			BaseIcon,
			BaseFileInput,
		},
		mixins: [],
		props: {
			//imageObject: [Object, Boolean],
			//text: [String],
			myProp: {
				type     : [String, Boolean],
				default  : false,
				required : false,
			},
		},
		data(){
			return {}
		},
		watch: {
			someVar: {
				handler: function( to, from ) {
				},
				immediate : true,
				deep: true,
			},
		},
		computed: {
			app(){
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []

				//classes.push( this.$options.name + '--isAnimating')

				return classes
			},
			doc(){
				return this.app.doc
			},
		},
		methods: {
			doDownloadCsv(){
				//console.log('doDownloadCsv()')
				this.doc.downloadAsCsv( this.doc.filename )
			},
		},
		created(){},
		mounted(){},
		destroyed(){},
	}
</script>

<style lang="less">
	@import (reference) "../../less/vars.less";
	@import (reference) "../../less/mixins.less";
	@import (reference) "../../less/atoms.less";

	.AppSidebar { // vars
		//
	}
	.AppSidebar { // debug
		[showBorders2] & {}
	}
	.AppSidebar { // layout
		&__inner {
			display: flex;
			flex-direction: column;
			height: 100%;
			overflow-x: hidden;
			overflow-y: auto;
		}
		&__expander {
			flex-grow: 1;
		}
	}
	.AppSidebar { // styling
		background-color: @swatches[sidebarBg];
		color: @swatches[primary];

		&::after { // shadow left
			position: absolute;
			top: 0; right: 0; bottom: 0;
			width: 15px;
			transform: translateX(100%);
			background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
			opacity: 0.05;
			content: "";
		}

		&__logo {
			a {
				padding-bottom: 65%;
				display: block;
				background-image: url('../../assets/imgs/logo.png');
				background-position: center;
				background-repeat: no-repeat;
				background-size: contain;
			}
		}
		&__box {
			padding: 15px;
			//& + & { border-top: 1px solid fade(@swatches[primary], 35); }
			border-top: 1px solid fade(@swatches[primary], 35);
		}
		//&__footer { border: none; }
	}

	.AppSidebar__box--progress {
		.BaseProgressBar {
			--height : 0.5em;
			--borderRadius : 0.25em;
			--trackBackgroundColor : @swatches[primaryLight];
			--valueBackgroundColor : @swatches[primary];

			margin-bottom: 0.5em;
		}
	}
	.AppSidebar__box--download {
		.BaseButton {
			margin-top: 1em;
			//margin-bottom: 0.5em;
			//margin: 0.5em 0;
			width: 100%;
		}
	}
	.AppSidebar__box--footer {
		display: flex;
		justify-content: center;

		a { padding: 0 0.5em; }
	}


	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
